import {ChatAIResponse} from "./database/chat-ia";

export interface IChatResponse {
  message: string;
  data?: IChatResponseData;
  dataType?: DataType;
  chartConfig?: IChartConfig;
}

export interface IChatResponseData {
  types: any;
  values: any[];
}

export  type DataType = "array" | "table";

export type TypeInputText = 'ASSISTANT' | 'USER';
export type TypeChart = 'line' | 'bar' | 'radar' | 'pie' | 'doughnut' | 'polarArea' | 'stacked';

export class ChatMessage {
  user?: string;
  dateTime: Date;
  prompt: string;
  response?: ChatAIResponse;
  type: TypeInputText;

  constructor(prompt: string, type: TypeInputText = 'ASSISTANT') {
    this.prompt = prompt;
    this.type = type;
    this.dateTime = new Date();
    this.asignaUser()
  }

  set dateTimeStr(dateTime: string) {
    this.dateTime = new Date(dateTime);
  }

  static fromChatResponseToChatMessage(data: IChatResponse, typeInput: TypeInputText): ChatMessage {
    const obj = new ChatMessage(data.message, typeInput);
    return obj;
  }

  asignaUser() {
    if (!this.user && this.type) {
      this.user = (this.type == 'USER') ? 'Usuario' : 'Bot';
    }
  }

}

export interface DataChat {
  columns: string[];
}


export interface IStyleChart {
  textColor?: string;
  textColorSecondary?: string;
  textSize?: string;
  font?: string;
  textAlign?: string;
  surfaceBorder?: string;
}

export interface IChartConfig {
    typeChart: TypeChart;
    xAxis: string;
    yAxis: string[] ;
    groups?: string;
    nombreDataSet?: string;
    stacked?: boolean;
    orientation?: 'x' | 'y';
    cutoutPercentage?: number;
    title?: string;
    xAxisTitle?: string;
    yAxisTitle?: string;
    time?:string;
    minLine?:string;
    maxLine?:string;
}

